import { Chapter, FadeUp } from "./Reveal";

const FACTS = [
    "Founder of CNI Channel, Ludhiana's first online web channel",
    "Interviews with nationally recognized personalities",
    "On judging panels across the region",
    "Government-recognized by DC Ludhiana",
    "More than a decade inside the regional business ecosystem",
];

const Founder = () => (
    <section id="founder" className="bg-mist py-24 md:py-32 overflow-hidden" data-testid="founder-section">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
            <Chapter
                index="04"
                label="The Founder"
                title={["Led by a founder,", "not a freelancer."]}
            />

            <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
                <FadeUp className="lg:col-span-5">
                    <div className="relative max-w-md" data-testid="founder-photo">
                        <div className="relative rounded-lg border border-slate-300 bg-white aspect-[3/4] overflow-hidden">
                            <img
                                src="/kuunal-pruuthi.jpg"
                                alt="Kuunal Pruuthi, Founder of ChatProz"
                                className="absolute inset-0 w-full h-full object-cover object-top"
                                loading="lazy"
                            />
                        </div>
                        <div className="mt-5">
                            <p className="font-display font-semibold text-2xl text-navy">Kuunal Pruuthi</p>
                            <p className="text-xs uppercase tracking-[0.25em] text-slate-400 mt-1">
                                Founder · ChatProz · CNI Channel
                            </p>
                        </div>
                    </div>
                </FadeUp>

                <div className="lg:col-span-7">
                    <FadeUp delay={0.1}>
                        <p className="font-display text-2xl md:text-3xl lg:text-[2.1rem] font-medium leading-snug tracking-tight text-navy max-w-2xl">
                            More Than a Decade of Expertise in marketing, branding, and business, spent inside the
                            rooms where regional business actually happens.
                        </p>
                    </FadeUp>
                    <FadeUp delay={0.2}>
                        <p className="mt-8 max-w-xl text-base md:text-lg leading-relaxed text-slate-600">
                            Kuunal built CNI Channel into Ludhiana's first online web channel, interviewing
                            nationally recognized personalities, sitting on judging panels, and earning government
                            recognition from the DC Ludhiana. ChatProz is that same network and instinct, turned into
                            a growth engine for your business.{" "}
                            <span className="font-semibold text-navy">
                                Today, we're helping traditional businesses become AI technology-driven businesses.
                            </span>
                        </p>
                    </FadeUp>
                    <FadeUp delay={0.3}>
                        <ul className="mt-10 grid sm:grid-cols-2 gap-x-8 gap-y-5 max-w-2xl">
                            {FACTS.map((fact, i) => (
                                <li key={i} className="flex items-start gap-3 text-sm md:text-base text-slate-700 leading-relaxed">
                                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-accent shrink-0" />
                                    {fact}
                                </li>
                            ))}
                        </ul>
                    </FadeUp>
                    <FadeUp delay={0.4}>
                        <a
                            href="https://kuunalpruuthi.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="founder-site-link"
                            className="mt-10 inline-block text-sm font-semibold text-accent hover:text-navy transition-colors duration-200 border-b border-accent/40 pb-0.5"
                        >
                            kuunalpruuthi.com
                        </a>
                    </FadeUp>
                </div>
            </div>
        </div>
    </section>
);

export default Founder;
